import actions from './actions'
import getters from './getters'
import mutations from "./mutations";

export default {
    namespaced: true,
    state: {
        page: {},
        car: {},
        banks: [],
        newCar: {},
        dataCarLoadedFlag: false,
        curBanner: 0,
        resCars:[]
    },
    mutations,
    actions,
    getters
}